import React, { useState } from 'react';
import { AnalyticsActionSheet } from './analytics-action-sheet';
import { AnalyticsAlert } from './analytics-alert';
import { AnalyticsAlertResponse } from './types';
import { AnalyticsAlertStatusType } from '@/types';
import { getTranslationValue } from '@/utils/translations';

interface AnalyticsAlertWithActionSheetProps {
  alert: AnalyticsAlertResponse;
  onAction: (
    alert: AnalyticsAlertResponse,
    actionType: AnalyticsAlertStatusType,
  ) => void;
  onSupportInfoPress?: (alert: AnalyticsAlertResponse) => void;
}

export const AnalyticsAlertWithActionSheet: React.FC<
  AnalyticsAlertWithActionSheetProps
> = ({ alert, onAction, onSupportInfoPress }) => {
  const [showActionSheet, setActionSheet] = useState(false);

  return (
    <>
      <AnalyticsAlert
        alertText={getTranslationValue(alert.title!)}
        onPress={() => {
          setActionSheet(true);
        }}
      />
      {showActionSheet && (
        <AnalyticsActionSheet
          alert={alert}
          onAction={onAction}
          onClose={() => setActionSheet(false)}
          onSupportInfoPress={onSupportInfoPress}
        />
      )}
    </>
  );
};
